<template>
  <div class="home">
    <v-container fluid fill-height class="loginOverlay">
      <LoginAndForgot />
    </v-container>
  </div>
</template>

<script>
import LoginAndForgot from "./LoginAndForgot.vue";

export default {
  name: "Home",
  components: {
    LoginAndForgot,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.loginOverlay {
  background: rgba(255, 255, 255, 0);
  padding: 0 !important;
}

.home {
  // max-height: 100%;
  // max-width: 100vw;
  // min-width: 100vw;
  // min-height: 100%;
  // background-image: url("../../assets/img/loginBackground_withlogo.png");
  // background-size: cover;
  // overflow: hidden;
}
</style>
